import { genKey } from 'draft-js';

/**
 * @param {string} nodeName
 * @param {HTMLElement} node
 */
export function findTableBlock(nodeName, node) {
	if (nodeName === 'table'
		|| /* 编辑器内部 */ node.firstElementChild && node.firstElementChild.tagName.toLowerCase() === 'table') {
		if (node.firstElementChild && node.firstElementChild.tagName.toLowerCase() === 'table') {
			node = node.firstElementChild
		}
		const tableRows = [].slice.call(node.querySelectorAll('tr'));
		const [headerRow, ...recordRows] = tableRows;
		if (headerRow) {
			const headerCells = [].slice.call(headerRow.querySelectorAll('td, th'));
			const numberOfCells = headerCells.length;
			const aligns = headerCells.map(x => ({
				key: genKey(),
				align: /align-(\w+)/.test(x.className) ? RegExp.$1 :  'left'
			}));
			const rows = tableRows.map((tableRow, rowIndex) => {
				const rowCells = [].slice.call(tableRow.querySelectorAll('td, th'), 0);
				return {
					key: genKey(),
					cells: rowCells.map((/** @type {HTMLTableCellElement}*/ td) => {
						const cell = {
							key: genKey(),
							raw: {
								blocks: [{
									key: genKey(),
									type: 'unstyled',
									text: String(td.textContent).trim(),
									inlineStyleRanges: [],
									entityRanges: [],
								}],
								entityMap: {},
							}
						};
						// 表头不能进行行合并
						if (td.rowSpan > 1 && rowIndex > 0) {
							cell.rowspan = td.rowSpan;
							cell.colspan = 1;
						}
						if (td.colSpan > 1) {
							cell.rowspan = cell.rowspan || 1;
							cell.colspan = td.colSpan;
						}
						return cell;
					})
				}
			});

			const insertPlaceholderCell = (i, j, count) => {
				const cells = [];
				while (count--) {
					cells.push({ key: genKey(), raw: null });
				}
				if (rows[i]) {
					rows[i].cells.splice(j, 0, ...cells);
				}
			};
			for (let i = 0; i < rows.length; i++) {
				const row = rows[i];
				let j = 0, cell;

				while (cell = row.cells[j]) {
					if (cell.colspan > 1) {
						insertPlaceholderCell(i, j + 1, cell.colspan - 1);
					}
					if (cell.rowspan > 1) {
						for (let di = 1; di < cell.rowspan; di++) {
							insertPlaceholderCell(i + di, j, cell.colspan || 1);
						}
					}
					++j;
				}
			}

			return {
				type: 'table',
				text: '[表格]',
				data: { aligns, rows },
				inlineStyleRanges: [],
				entityRanges: [],
			};
		}
	}
}



// WEBPACK FOOTER //
// ./lib/convert/html/finder/findTableBlock.js